import React from 'react'
import Popover from 'react-popover'
import PropTypes from 'prop-types'
import styles from './popover.module.scss'

/**
 *
 * @param children is a target when popover is anchor element
 */
const PopoverBase = ({
  isOpen,
  onOuterAction,
  body,
  preferPlace,
  children
}) => (
  <Popover
    isOpen={isOpen}
    preferPlace={preferPlace}
    onOuterAction={onOuterAction}
    body={[
      <div key="content" className={styles.container}>
        {body}
      </div>
    ]}
  >
    {children}
  </Popover>
)

PopoverBase.defaultProps = {
  isOpen: false,
  onOuterAction: undefined,
  preferPlace: 'right'
}

PopoverBase.propTypes = {
  isOpen: PropTypes.bool,
  onOuterAction: PropTypes.func,
  preferPlace: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired
}

export default React.memo(PopoverBase)
